import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { delay } from 'lodash';
import gradient from 'random-gradient';
import initials from 'initials';
import getLogo, { getPalleteFromId } from './logo-service';
import Spinner from '../../../../components/spinner';
import styles from './styles.css';

class AccountLogo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
      logo: null,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.checkProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const currentAccount = this.props.account || {};
    const newAccount = nextProps.account || {};
    if (newAccount.account_id !== currentAccount.account_id && newAccount.account_id) {
      this.checkProps(nextProps);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadLogo(logo) {
    return new Promise((resolve, reject) => {
      if (typeof window !== 'undefined') {
        const image = new window.Image();
        image.onload = () => {
          resolve(logo);
        };
        image.onerror = (error) => {
          reject(error);
        };
        delay(() => {
          resolve(null);
        }, 3000); // timeout
        image.src = logo;
      } else {
        resolve(logo);
      }
    });
  }

  checkProps(props) {
    this.setState({ loading: true, logo: null, loaded: false }, () => {
      const { account } = props;
      getLogo({ url: account.website, name: account.name, id: account.account_id })
        .then(
          ({ logo, colorPallete }) => {
            if (this.mounted) {
              this.loadLogo(logo)
                .then(
                  () => {
                    if (this.mounted) {
                      this.setState({ loading: false, logo, loaded: true });
                      this.props.onLogoLoaded(logo, colorPallete);
                    }
                  },
                  () => {
                    if (this.mounted) {
                      this.setState({ loading: false });
                    }
                  },
                );
            }
          },
          () => {
            if (this.mounted) {
              if (account.account_id) {
                const colorPallete = {};
                const [primaryColor, secondaryColor] = getPalleteFromId(account.account_id);
                if (primaryColor && secondaryColor) {
                  colorPallete.vibrant = primaryColor;
                  colorPallete.darkVibrant = secondaryColor;
                }
                this.props.onLogoLoaded(null, colorPallete);
              }
              this.setState({ loading: false });
            }
          },
        );
    });
  }

  render() {
    const { logo, loaded, loading } = this.state;
    const { account, size } = this.props;
    if (!account) {
      return null;
    }
    if (loading) {
      return (
        <div className={styles.logo} style={{ width: size }}>
          <Spinner autoSize />
        </div>
      );
    }

    const name = initials(account.name);
    let src = null;
    if (loaded && logo) {
      src = logo;
    }

    const innerStyles = {};
    if (src !== null) {
      innerStyles.backgroundImage = `url(${src})`;
    } else {
      innerStyles.background = gradient(account.account_id);
    }

    return (
      <div className={styles.logo} style={{ width: size }}>
        <span className={styles.logoImg} style={innerStyles} />
        {src === null && <span style={{ lineHeight: `${size}px` }} className={styles.logoName}>{name}</span>}
      </div>
    );
  }
}

AccountLogo.propTypes = {
  account: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  size: PropTypes.number,
  onLogoLoaded: PropTypes.func,
};

AccountLogo.defaultProps = {
  size: 48,
  onLogoLoaded: () => {},
};


export default AccountLogo;
